/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { EmailTemplateType } from '@gh/builder-shared-data';

import { DialogInput } from '@gh/core-ui';

import { isNil } from 'lodash';

import { EmailTemplatePreviewDialogConfig } from '../../resources/email-template-details-business.service';
import { FOOTER_EMAIL_TEMPLATE_SUBJECT, HEADER_EMAIL_TEMPLATE_SUBJECT } from '../../resources/email-template.model';

@Component({
  selector: 'gh-email-template-preview',
  template: require('./email-template-preview.component.html'),
  styles: [require('./email-template-preview.component.scss')],
})
export class EmailTemplatePreviewComponent implements DialogInput<EmailTemplatePreviewDialogConfig> {
  input: EmailTemplatePreviewDialogConfig;

  constructor(private dialogRef: MatDialogRef<EmailTemplatePreviewComponent>) {
  }

  isEmailHeaderInvisible(): boolean {
    return (this.input.type === EmailTemplateType.Layout
      && (this.isMasterTemplate() || this.isCorporateTemplate())
      && this.input.subject === FOOTER_EMAIL_TEMPLATE_SUBJECT
      || this.isOfficeTemplate());
  }

  isEmailFooterInvisible(): boolean {
    return (this.input.type === EmailTemplateType.Layout
      && (this.isMasterTemplate() || this.isCorporateTemplate())
      && this.input.subject === HEADER_EMAIL_TEMPLATE_SUBJECT
      || this.isOfficeTemplate());
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private isCorporateTemplate(): boolean {
    return isNil(this.input.masterZoneId) && isNil(this.input.officeId);
  }

  private isMasterTemplate(): boolean {
    return !isNil(this.input.masterZoneId) && isNil(this.input.officeId);
  }

  private isOfficeTemplate(): boolean {
    return isNil(this.input.masterZoneId) && !isNil(this.input.officeId);
  }
}
